import { render } from "./LocalTable.vue?vue&type=template&id=6b9d67a5"
import script from "./LocalTable.vue?vue&type=script&lang=js"
export * from "./LocalTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__